import { apiClient } from '@/lib/api-client';
import type { ApiResponse } from '@/types/api';

export interface SaltUnitType {
  id: string;
  wireCode: string;
  displayName: string;
  isActive: boolean;
  isSystem: boolean;
  deviceCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreateSaltUnitTypeRequest {
  wireCode: string;
  displayName: string;
}

export interface UpdateSaltUnitTypeRequest {
  displayName?: string;
  isActive?: boolean;
}

export async function listSaltUnitTypes(activeOnly = false): Promise<SaltUnitType[]> {
  const q = activeOnly ? '?activeOnly=true' : '';
  const response = await apiClient.get<SaltUnitType[]>(`/saltunittypes${q}`);
  return response.data;
}

export async function createSaltUnitType(data: CreateSaltUnitTypeRequest): Promise<ApiResponse<SaltUnitType>> {
  const response = await apiClient.post<ApiResponse<SaltUnitType>>('/saltunittypes', data);
  return response.data;
}

export async function updateSaltUnitType(id: string, data: UpdateSaltUnitTypeRequest): Promise<ApiResponse<SaltUnitType>> {
  const response = await apiClient.patch<ApiResponse<SaltUnitType>>(`/saltunittypes/${id}`, data);
  return response.data;
}
